import { SapAssetDetail } from "@/features"

const SapAssetDetailPage = () => {
  return <SapAssetDetail />
}

export default SapAssetDetailPage
